/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Hero_LedeInputs */

const en_help_hero_lede = /** @type {(inputs: Help_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step-by-step answers on your calendar, clients, plans and payments, written by the people who build the app.`)
};

const pl_help_hero_lede = /** @type {(inputs: Help_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrukcje krok po kroku o kalendarzu, podopiecznych, planach i płatnościach, napisane przez ludzi, którzy tworzą aplikację.`)
};

/**
* | output |
* | --- |
* | "Step-by-step answers on your calendar, clients, plans and payments, written by the people who build the app." |
*
* @param {Help_Hero_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_hero_lede = /** @type {((inputs?: Help_Hero_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Hero_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_hero_lede(inputs)
	return en_help_hero_lede(inputs)
});